<template>
  <Aside :width="400" v-model="open">
    <div class="user">
      <div class="margin-bottom-10px">
        <h1>{{ today }}</h1>
        <p class="text-orange" v-if="!canExam">考试日为每月{{examinationDay.join('/')}}号，当前非考试日，无法参加考试</p>
      </div>
      
      <Alert type="warning" show-icon v-if="canEdit">
          <p class="text-paragraph text-bold">身份信息未完善！</p>
          <template slot="desc">
            <p class="text-paragraph">您当前的身份信息还未完善，将导致以下功能无法正常使用：</p>
            <p class="text-bold text-indent">1、考试功能</p>
            <p class="text-bold text-indent">2、电子证书发放</p>
            <p class="text-bold text-indent">3、实体证书寄送</p>
            <Button class="margin-top-10px" type="primary" long @click="handleEditUserInfo">立刻完善身份信息</Button>
          </template>
      </Alert>

      <div class="user-info margin-bottom-10px">
        <p class="text-paragraph text-bold text-large">
          <Avatar :src="userInfo.avatar" />
          {{ userInfo.realName || userInfo.nickName }}
        </p>

        <Card title="我的身份信息" :padding="10">
          <a slot="extra" v-if="canEdit" @click.prevent="handleEditUserInfo">编辑</a>
          <CellGroup>
            <Cell title="真实姓名">
              <p class="user-info-item text-over" slot="extra" v-if="userInfo.realName">{{ userInfo.realName }}</p>
              <Badge slot="extra" text="未填写" v-else />
            </Cell>
            <Cell title="身份证号码">
              <p class="user-info-item text-over" slot="extra" v-if="userInfo.idCardSeriesNo">{{ userInfo.idCardSeriesNo }}</p>
              <Badge slot="extra" text="未填写" v-else />
            </Cell>
            <Cell title="性别">
              <p class="user-info-item text-over" slot="extra" v-if="userInfo.sex">{{ userInfo.sex | getSexText }}</p>
              <Badge slot="extra" text="未填写" v-else />
            </Cell>
            <Cell title="教育程度">
              <p class="user-info-item text-over" slot="extra" v-if="userInfo.education">{{ userInfo.education | getEducationText }}</p>
              <Badge slot="extra" text="未填写" v-else />
            </Cell>
          </CellGroup>
        </Card>
      </div>

      <BrowserTest />

      <Button
        class="margin-top-10px"
        type="primary"
        ghost
        long
        @click="handleSearchDiploma">
        证书查询
      </Button>
    </div>
  </Aside>
</template>

<script>
import { mapState } from 'vuex'
import { USER } from '../../../libs/namespace'
import { EDUCATION_TYPE, SEX_TYPE, getLabelByValue } from '../../../libs/constant'
import Aside from '../../../components/Aside'
import BrowserTest from '../../../components/BrowserTest'

let openAside = true

export default {
  components: { Aside, BrowserTest },
  filters: {
    getEducationText (value) {
      return getLabelByValue(value, EDUCATION_TYPE)
    },
    getSexText (value) {
      return getLabelByValue(value, SEX_TYPE)
    }
  },
  computed: {
    ...mapState([ 'today', 'canExam', 'examinationDay' ]),
    ...mapState(USER, [ 'userInfo' ]),

    open: {
      get: () => openAside,
      set: value => { openAside = value }
    },

    canEdit () {
      return !this.userInfo.idCardSeriesNo
    }
  },
  created () {
    this.userInfoTip()
  },
  handlers: {
    handleSearchDiploma () {
      this.openDialog({
        name: '/dialogs/searchDiploma'
      })
    },

    handleEditUserInfo () {
      this.openDialog({
        name: '/user/dialogs/userInfo'
      })
    }
  },
  methods: {
    async userInfoTip () {
      if (!this.userInfo.idCardSeriesNo) {
        const flag = await window.confirm({
          title: '个人信息未完善',
          content: `
            <p class="text-paragraph">您当前的身份信息还未完善，将导致以下功能无法正常使用：</p>
            <p class="text-bold text-indent">1、考试功能</p>
            <p class="text-bold text-indent">2、电子证书发放</p>
            <p class="text-bold text-indent">3、实体证书寄送</p>
          `
        })
        if (flag) this.handleEditUserInfo()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.user {
  width: 400px;
  padding: 10px;

  &-info {
    padding: 10px;
    .ivu-avatar {
      width: 40px;
      height: 40px;
      margin-right: 10px;
      border-radius: 50%;
    }
    &-item {
      width: 200px;
      text-align: right;
    }
  }
}
</style>
